import { HTMLAttributes, ReactNode } from 'react';
import { useStore } from 'effector-react';
import { formatBagId } from '@lib/bag-formatting';
import { WarehouseBagTemplate } from '@ui/bag-template/list';
import { warehouseModel } from '@entities/warehouse';
import { simpleMix } from '@entities/simple-mix';
import { AgricultureHintParameters } from '@@/agriculture/components/agriculture-hint-paramaters';
import { dateFormatter, DATE_FORMAT } from '@lib/date-formatting';

import { BagMainParameters } from '@@/bags/components/bag-main-parameters';
import {
  $agricultureById,
  $agricultureIsLoading,
} from '@@/agriculture/store/agriculture.store';
import { IBag } from '@@/bags/ts';
import { Loader } from '@ui/loader';

import styles from './styles.module.css';

export function FilledBag(props: IFilledBagProps) {
  const { id, bag, type, actions, ...rest } = props;
  const currentBag = bag ?? warehouseModel.useBag(id);
  const agricultureById = useStore($agricultureById);
  const agricultureIsLoading = useStore($agricultureIsLoading);

  if (!currentBag.agricultureId) return null;
  // if (agricultureIsLoading) return <Loader />;

  const formattedId = formatBagId(currentBag.id);
  const isMixed = simpleMix.isBagMixed(currentBag.id);
  const filled = dateFormatter(currentBag.fillingDate).format(DATE_FORMAT);

  const culture = agricultureById[currentBag.agricultureId as number];

  return (
    <WarehouseBagTemplate
      type={type}
      cultureName={culture.name}
      image={<img src={culture.img} alt={culture.name} />}
      borderColor={culture.color}
      backgroundColor={culture.color}
      sleeveId={formattedId}
      mixed={isMixed}
      filled={filled}
      params={
        <AgricultureHintParameters params={currentBag.values}>
          <BagMainParameters bag={currentBag} />
        </AgricultureHintParameters>
      }
      attention={false}
      actions={actions}
      {...rest}
    />
  );
}

export interface IFilledBagProps extends HTMLAttributes<HTMLDivElement> {
  id: IBag['id'];
  bag?: IBag;
  type: 'sleeve' | 'bunker';
  actions?: ReactNode;
}
